// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"13dc1704","519":"099820b4","669":"099820b4"}[chunkId] + ".chunk.css";
};